var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title'),_c('b-card',{staticClass:"mt-1",attrs:{"no-body":""}},[_c('b-card-body',[_c('iframe',{staticStyle:{"width":"100%","height":"80vh"},attrs:{"src":"/scds/carbon_report.pdf","frameborder":"0"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }